import { render, staticRenderFns } from "./NotifyAbsence.vue?vue&type=template&id=053406ba"
import script from "./NotifyAbsence.vue?vue&type=script&lang=js"
export * from "./NotifyAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports